import { ModalOverlay } from "@vernost_dev/vms-react-components/dist/ModalOverlay";
import { useEffect } from 'react'

export const VmsModalOverlay = ({
  children,
  footerButtons,
  title,
  titleProps,
  onModalClose,
  onModalOpen,
  additionalClassName,
  additionalStyle,
  isOpen,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return (
    <ModalOverlay
      isOpen={isOpen}
      footerButtons={footerButtons}
      title={title}
      titleProps={titleProps}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      additionalClassName={additionalClassName}
      additionalStyle={additionalStyle}
    >
      {children}
    </ModalOverlay>
  );
};
